import React, { Suspense, useRef, useState } from 'react';

import AddOnInfoOverlay from '../AddOnsOverlay';
import { faOnAddonCardClick, faOnTncClick } from './analytics-services';

import './style.scss';

const PopUp = React.lazy(() => import('../../../../../../../../common/component/popup/PopUp'));

const cardsToShow = 2;

const AddOnSection = ({ sectionData }) => {
  const { header, cards = [] } = sectionData;

  const cardListRef = useRef(null);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [showOverLay, setShowOverlay] = useState(false);

  if (cards.length === 0) {
    return null;
  }

  const handleLeftClick = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
      cardListRef.current.scrollTo({
        left: cardListRef.current.scrollLeft - cardListRef.current.offsetWidth / cardsToShow,
        behavior: 'smooth',
      });
    }
  };

  const handleRightClick = () => {
    if (currentIndex < cards.length - cardsToShow) {
      setCurrentIndex(currentIndex + 1);
      cardListRef.current.scrollTo({
        left: cardListRef.current.scrollLeft + cardListRef.current.offsetWidth / cardsToShow,
        behavior: 'smooth',
      });
    }
  };

  const closeOverlay = () => {
    setShowOverlay(false);
  };

  const handleCardClick = () => {
    faOnAddonCardClick();
    setShowOverlay(prev => !prev);
  };

  return (
    <div className="add-on-section">
      <div className="title-container">
        <span className="title">{header}</span>
        {cards.length > cardsToShow && (
          <div className="buttons-container">
            <span
              className={`left-arrow ${currentIndex <= 0 ? '-disabled' : ''} `}
              onClick={handleLeftClick}
            >
              <span className="icon mmt-chevron-left" />
            </span>
            <span className="cta-seperator" />
            <span
              className={`right-arrow ${
                currentIndex >= cards.length - cardsToShow ? '-disabled' : ''
              }`}
              onClick={handleRightClick}
            >
              <span className="icon mmt-chevron-right" />
            </span>
          </div>
        )}
      </div>
      <ul className="addon-section-card-list" ref={cardListRef}>
        {cards.map(({ id, order, iconUrl, header, subHeader, tag, cta, description }) => (
          <li
            key={id}
            className={`addon-section-card-container${cards.length > 1 ? ' -half ' : ''}`}
            onClick={handleCardClick}
          >
            <div className="addon-section-card-item">
              <div className="icon-container">
                <img src={iconUrl} alt={'icn'} />
              </div>
              <div className="addon-info-container">
                <div className="header-container">
                  <div className="header">
                    <h3>{header}</h3>
                  </div>
                  <div className="tag">
                    <div>{tag}</div>
                  </div>
                </div>
                <div className="description-container">
                  {description.map(({ text, colour, bold }) => (
                    <span
                      style={{ color: colour }}
                      className={`addon-description${bold ? ' -bold' : ''}`}
                    >
                      {text}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <div className="cta-container">
              <span className="addon-section-cta">
                <span className="icon mmt-chevron-right" />
              </span>
            </div>
          </li>
        ))}
      </ul>
      {showOverLay && (
        <Suspense fallback="">
          <PopUp
            width={750}
            className="sidePannelWrapper sidePannel"
            onClose={closeOverlay}
            hideOuterCrossIcon
            containerClassName="addonSectionOverlay"
          >
            <AddOnInfoOverlay {...{ closeOverlay, onTncClick: faOnTncClick }} />
          </PopUp>
        </Suspense>
      )}
    </div>
  );
};

export default AddOnSection;
